

export const SelectArrowDown = ({ className }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
    >
      <mask
        id="mask0_53_332"
        maskUnits="userSpaceOnUse"
        x="3"
        y="6"
        width="10"
        height="6"
      >
        <path
          d="M12 6.66663L8 10.6666L4 6.66663L12 6.66663Z"
          fill="white"
          stroke="white"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_53_332)">
        <path
          d="M16 0L16 16L-6.99382e-07 16L0 -6.99382e-07L16 0Z"
          fill="#3182CE"
        />
      </g>
    </svg>
  );
};
export const ArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_45_173"
        maskUnits="userSpaceOnUse"
        x="6"
        y="3"
        width="6"
        height="10"
      >
        <path
          d="M6.66666 4L10.6667 8L6.66666 12V4Z"
          fill="white"
          stroke="white"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_45_173)">
        <path d="M0 0H16V16H0V0Z" fill="#A0AEC0" />
      </g>
    </svg>
  );
};

export const BellSvg = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M6.25 23.75C5.89584 23.75 5.59875 23.63 5.35875 23.39C5.11875 23.15 4.99917 22.8533 5 22.5C5 22.1458 5.12 21.8488 5.36 21.6088C5.6 21.3688 5.89667 21.2492 6.25 21.25H7.5V12.5C7.5 10.7708 8.02084 9.23417 9.0625 7.89C10.1042 6.54584 11.4583 5.66584 13.125 5.25V4.375C13.125 3.85417 13.3075 3.41125 13.6725 3.04625C14.0375 2.68125 14.48 2.49917 15 2.5C15.5208 2.5 15.9638 2.6825 16.3288 3.0475C16.6938 3.4125 16.8758 3.855 16.875 4.375V5.25C18.5417 5.66667 19.8958 6.54709 20.9375 7.89125C21.9792 9.23542 22.5 10.7717 22.5 12.5V21.25H23.75C24.1042 21.25 24.4013 21.37 24.6413 21.61C24.8813 21.85 25.0008 22.1467 25 22.5C25 22.8542 24.88 23.1513 24.64 23.3913C24.4 23.6313 24.1033 23.7508 23.75 23.75H6.25ZM15 27.5C14.3125 27.5 13.7238 27.255 13.2338 26.765C12.7438 26.275 12.4992 25.6867 12.5 25H17.5C17.5 25.6875 17.255 26.2763 16.765 26.7663C16.275 27.2563 15.6867 27.5008 15 27.5Z"
          fill="rgb(140, 140, 140)"
        />
      </svg>
    </div>
  );
};
export const UserSvg = ({ onClick }: any) => {
  return (
    <svg
      onClick={() => onClick()}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 5C13.251 4.99968 11.5324 5.45811 10.0159 6.32954C8.4994 7.20096 7.23797 8.4549 6.35753 9.96619C5.4771 11.4775 5.00844 13.1933 4.99835 14.9423C4.98825 16.6913 5.43708 18.4124 6.30001 19.9338C6.88328 19.1757 7.63305 18.562 8.49137 18.14C9.34969 17.718 10.2936 17.499 11.25 17.5H18.75C19.7065 17.499 20.6503 17.718 21.5087 18.14C22.367 18.562 23.1167 19.1757 23.7 19.9338C24.563 18.4124 25.0118 16.6913 25.0017 14.9423C24.9916 13.1933 24.5229 11.4775 23.6425 9.96619C22.7621 8.4549 21.5006 7.20096 19.9841 6.32954C18.4676 5.45811 16.7491 4.99968 15 5ZM24.9288 22.595C26.6 20.4162 27.504 17.746 27.5 15C27.5 8.09625 21.9038 2.5 15 2.5C8.09626 2.5 2.50001 8.09625 2.50001 15C2.49589 17.746 3.3999 20.4163 5.07126 22.595L5.06501 22.6175L5.50876 23.1338C6.68112 24.5044 8.13674 25.6045 9.7753 26.3583C11.4139 27.1121 13.1964 27.5016 15 27.5C17.5342 27.5047 20.0093 26.7349 22.0938 25.2938C22.9824 24.6798 23.7882 23.9538 24.4913 23.1338L24.935 22.6175L24.9288 22.595ZM15 7.5C14.0055 7.5 13.0516 7.89509 12.3484 8.59835C11.6451 9.30161 11.25 10.2554 11.25 11.25C11.25 12.2446 11.6451 13.1984 12.3484 13.9017C13.0516 14.6049 14.0055 15 15 15C15.9946 15 16.9484 14.6049 17.6517 13.9017C18.3549 13.1984 18.75 12.2446 18.75 11.25C18.75 10.2554 18.3549 9.30161 17.6517 8.59835C16.9484 7.89509 15.9946 7.5 15 7.5Z"
        fill="rgb(140, 140, 140)"
      />
    </svg>
  );
};
export const UserImgSvg = ({ onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00001 6.66683C9.47277 6.66683 10.6667 5.47292 10.6667 4.00016C10.6667 2.5274 9.47277 1.3335 8.00001 1.3335C6.52725 1.3335 5.33334 2.5274 5.33334 4.00016C5.33334 5.47292 6.52725 6.66683 8.00001 6.66683Z"
        fill="#667085"
        fillOpacity="0.63"
      />
      <path
        d="M13.3333 11.667C13.3333 13.3237 13.3333 14.667 8.00001 14.667C2.66667 14.667 2.66667 13.3237 2.66667 11.667C2.66667 10.0103 5.05467 8.66699 8.00001 8.66699C10.9453 8.66699 13.3333 10.0103 13.3333 11.667Z"
        fill="#667085"
        fillOpacity="0.63"
      />
    </svg>
  );
};
export const SearchSvg = ({ onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M14.0177 14L11.1224 11.1047M11.1224 11.1047C11.6176 10.6094 12.0105 10.0215 12.2785 9.37438C12.5466 8.72729 12.6845 8.03375 12.6845 7.33335C12.6845 6.63295 12.5466 5.9394 12.2785 5.29232C12.0105 4.64523 11.6176 4.05727 11.1224 3.56202C10.6271 3.06676 10.0392 2.6739 9.39208 2.40586C8.74499 2.13783 8.05145 1.99988 7.35105 1.99988C6.65065 1.99988 5.9571 2.13783 5.31002 2.40586C4.66293 2.6739 4.07497 3.06676 3.57972 3.56202C2.5795 4.56224 2.01758 5.91882 2.01758 7.33335C2.01758 8.74787 2.5795 10.1045 3.57972 11.1047C4.57994 12.1049 5.93652 12.6668 7.35105 12.6668C8.76557 12.6668 10.1222 12.1049 11.1224 11.1047Z"
        stroke="#3182CE"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};


export const ToothSvg = ({ color, onClick }: any) => {
  return (
    <div className="toothsvgone">
      <svg
        viewBox="181.818 261.818 498.181 188.182"
        width="35"
        height="63"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path
          strokeWidth="10"
          fill={color}
          style={{ stroke: "rgb(0, 0, 0)" }}
          d="M 181.507 301.928 L 332.02 449.634 C 332.02 449.634 426.933 357.53 528.024 449.636 L 679.662 303.614 C 679.662 303.614 655.518 231.704 471.301 280.589 C 446.875 287.072 440.412 285.08 411.77 282.833 C 383.128 280.587 216.889 224.989 181.507 301.928 Z"
          transform="matrix(1, 0, 0, 1, -2.842170943040401e-14, 0)"
        />
      </svg>
    </div>
    
  );
};
export const BigToothSvg = ({ color, onClick }: any) => {
  return (
    <div className="toothsvgone">
      <svg
        viewBox="150 200 600 300" 
        width="200"   
        height="350" 
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path
          strokeWidth="10"
          fill={color}
          style={{ stroke: "rgb(0, 0, 0)" }}
          d="M 181.507 301.928 L 332.02 449.634 C 332.02 449.634 426.933 357.53 528.024 449.636 L 679.662 303.614 C 679.662 303.614 655.518 231.704 471.301 280.589 C 446.875 287.072 440.412 285.08 411.77 282.833 C 383.128 280.587 216.889 224.989 181.507 301.928 Z"
          transform="matrix(1, 0, 0, 1, -2.842170943040401e-14, 0)"
        />
      </svg>
    </div>
    
  );
};
export const DeleteSvg = ({ color, onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M4.49967 12.6667C4.49967 13.4 5.09967 14 5.83301 14H11.1663C11.8997 14 12.4997 13.4 12.4997 12.6667V4.66667H4.49967V12.6667ZM13.1663 2.66667H10.833L10.1663 2H6.83301L6.16634 2.66667H3.83301V4H13.1663V2.66667Z"
        fill="white"
      />
    </svg>
  );
};
export const EditSvg = ({ color, onClick }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_120_1880)">
        <path
          d="M1.40407 7.73334L0.770732 10.4667C0.748884 10.5666 0.749633 10.6701 0.772924 10.7697C0.796215 10.8693 0.84146 10.9624 0.905353 11.0423C0.969246 11.1222 1.05017 11.1868 1.14222 11.2313C1.23427 11.2759 1.33512 11.2994 1.4374 11.3C1.48506 11.3048 1.53308 11.3048 1.58073 11.3L4.33073 10.6667L9.61073 5.40667L6.66406 2.46667L1.40407 7.73334Z"
          fill="white"
        />
        <path
          d="M11.2706 2.77336L9.30397 0.806697C9.17467 0.678052 8.9997 0.605835 8.8173 0.605835C8.63491 0.605835 8.45994 0.678052 8.33064 0.806697L7.2373 1.90003L10.1806 4.84336L11.274 3.75003C11.338 3.68572 11.3886 3.60943 11.4231 3.52552C11.4576 3.44161 11.4751 3.35172 11.4748 3.26101C11.4745 3.17029 11.4563 3.08053 11.4213 2.99685C11.3863 2.91318 11.3351 2.83723 11.2706 2.77336Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_120_1880">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(-0.00292969)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ArrowLeftSVG = ({ onClick }: any) => (
  <svg
    onClick={onClick}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L9.41421 10L12.7071 13.2929C13.0976 13.6834 13.0976 14.3166 12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289Z"
      fill="#71717A"
    />
  </svg>
);
export const ArrowRightSVG = ({ onClick }: any) => (
  <svg
    onClick={onClick}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z"
      fill="#71717A"
    />
  </svg>
);
export const CloseSVG = ({ onClick }: any) => (
  <svg
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M18.3218 6.5L6.32178 18.5M6.32178 6.5L18.3218 18.5"
      stroke="#667085"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
